import styled from 'styled-components';

type StyledLogoContainerProps = {
  width?: number;
};
export const StyledLogoContainer = styled.div<StyledLogoContainerProps>`
  width: ${({ width }) => (width ? `${width}px` : '100%')};
  display: flex;
  justify-content: center;
  margin-bottom: 24px;
`;

export const StyledWelcomeText = styled.div`
  font-size: 20px;
  font-weight: 600;
  line-height: 24px;
  color: ${(props) => props.theme?.palette?.text?.[0]};
  margin-bottom: 24px;
`;
